import {FlagProps} from 'platform/components';

export const getFlagProps = (
  enumType: string,
  entityValue: string
): Pick<FlagProps, 'colorScheme' | 'isSubtle'> => ({
  colorScheme: 'neutral',
  isSubtle: true,
});
